export const SearchBoxCriterionGroup = Symbol('SEARCH');
